import type { GalleryItem } from '../types/content'

// Immagini originali del carosello, nell’ordine originale (senza testo, file invariati).
export const originalGallery: GalleryItem[] = [
  {
    id: 'g1',
    motif: 'bottiglie fiorite',
    src: 'https://cdn.magicpatterns.com/uploads/kXpVrc4kFykriyoFwWDxkQ/carrusel_3.jpg',
    alt: 'Bottiglie di vetro dipinte con fiori a effetto vetrata',
  },
  {
    id: 'g2',
    motif: 'tucano',
    src: 'https://cdn.magicpatterns.com/uploads/vdeDyxESwB5JbZgZCfNBeq/carrusel_4.jpg',
    alt: 'Disco rotondo dipinto con un tucano a effetto vetrata, tenuto in mano',
  },
  {
    id: 'g3',
    motif: 'pannello floreale',
    src: 'https://cdn.magicpatterns.com/uploads/uFy89FxUUY6diSQRckna1N/carrusel_5.jpg',
    alt: 'Pannello floreale con effetto vetrata durante la pittura',
  },
  {
    id: 'g4',
    motif: 'trio di bottiglie',
    src: 'https://cdn.magicpatterns.com/uploads/6tyBGPXE1LSgsUtZxERZJ6/carrusel_6.jpg',
    alt: 'Tre bottiglie decorate con fiori a effetto vetrata',
  },
  {
    id: 'g5',
    motif: 'vaso con tulipani',
    src: 'https://cdn.magicpatterns.com/uploads/hqGPV9QeBQ84RNWtMUheA1/carrusel_7.jpg',
    alt: 'Vaso di vetro dipinto con tulipani a effetto vetrata',
  },
  {
    id: 'g6',
    motif: 'arcobaleno',
    src: 'https://cdn.magicpatterns.com/uploads/eML6rD22YJ2krS3KsVpnw5/carrusel_8.jpg',
    alt: 'Arcobaleno con effetto vetrata appeso',
  },
  {
    id: 'g7',
    motif: 'calice',
    src: 'https://cdn.magicpatterns.com/uploads/p9eCGxnPDzH36xbAcxxB2Y/carrusel_9.jpg',
    alt: 'Calice decorato con fiori viola a effetto vetrata',
  },
  {
    id: 'g8',
    motif: 'tazza fiorita',
    src: 'https://cdn.magicpatterns.com/uploads/tDZefsvYpJkcgBzyA2gMBP/carrusel_10.jpg',
    alt: 'Tazza e piattino decorati con fiori',
  },
]
